import {findDOMNode} from 'react-dom';
import allStates from 'helpers/provinces';

export default class ValidateGroup {
  constructor(submit, cb = null) {
    this.components = [];
    this.submit = submit;
    this.callback = cb;
    this._keybind = this._keybind.bind(this);
    this._validate = this._validate.bind(this);
    this.validate = this.validate.bind(this);

    this._first = true;
  }

  addComponent(ref, addListener = true) {
    if (ref) {
      this.components.push(ref);
      if (addListener) {
        let _ref = findDOMNode(ref); // eslint-disable-line react/no-find-dom-node

        if (_ref) {
          _ref.addEventListener('keypress', this._keybind);
        }
      }
    }
  }

  removeComponent(ref, removeListener = true) {
    if (removeListener) {
      let _ref = findDOMNode(ref); // eslint-disable-line react/no-find-dom-node

      if (_ref) {
        _ref.removeEventListener('keypress', this._keybind);
      }
    }
    this.components = this.components.filter(x => x !== ref);
  }

  _keybind(e) {
    if (e.which === 13) {
      this.validate();
    }
  }

  get size() {
    return this.components.size;
  }

  get first() {
    if (this.size === 0 && this._first) {
      this._first = false;
      return true;
    }
    return false;
  }

  validate(e, ...args) {
    if (e && e.preventDefault) { // So can put on form submit
      e.preventDefault();
    }

    this._validate(e, ...args)
      .then(allValid => {
        if (allValid) {
          this.submit(...args);
        }else if(this.callback) {
          this.callback();
        }
      });
  }

  _validate() {
    let allValid = [];

    for (let ref of this.components) {
      if (ref && ref.validate) {
        let val = ref.validate();

        if (val instanceof Promise) {
          allValid.push(val);
        } else {
          allValid.push(Promise.resolve(val));
        }
      }
    }

    return Promise.all(allValid)
      .then(x => {
        for (let i = 0; i < x.length; ++i) {
          let result = x[i];

          if (result === false) {
            let ref = this.components[i];

            if (ref) {
              ref.focus();
              break;
            }
          }
        }
        return !!x.reduce((acc, y) => y && acc, true);
      });
  }
}

export function isValidEmail(email) {
  email = (email || '').trim();

  if (!(typeof email === 'string' && email.length > 0)) {
    return true;
  }

  if (email.length > 50) {
    return false;
  }

  let split = email.split('@');

  if (!(split.length === 2 && split[0].length > 0 && split[1].length > 0)) {
    return false;
  }

  let domain = split[1].split('.');

  return domain.length >= 2 && domain.every(x => x.length > 0);
}

export function isValidPhone(phone) {
  phone = (phone || '').trim();

  if (!phone || phone.length < 10) {
    return false;
  }

  let match = phone.match(/[0-9]/g);

  return match && match.length >= 10;
}

export function isValidState(state, country = 'US') {
  state = (state || '').trim();

  return allStates
    .filter(x => x.country === country)
    .map(x => x.short)
    .includes(state.toUpperCase());
}

export function isValidZip(zip, country) {
  if (country === 'CA') {
    return new RegExp(/[A-Z][0-9][A-Z][\s]?[0-9][A-Z][0-9]/)
      .test((zip || '').trim().toUpperCase());
  }

  zip = (zip || '').trim();

  if (zip.length !== 5 && zip.length !== 10) {
    return false;
  }

  let matches = zip.match(/[0-9]+/);

  if (matches.length === 1 && matches[0].length === 5 && zip.length === 5) {
    return true;
  }

  matches = zip.match(/[0-9]{5}-[0-9]{4}/);
  return matches.length === 1 && matches[0].length === 10 && zip.length === 10;
}

export function isValidURL(url) {
  url = (url || '').trim();

  if (!url) {
    return true;
  }

  if (typeof url !== 'string') {
    return false;
  }

  let split = url.split('.');

  if (split.length < 2) {
    return false;
  }

  return !split.some(x => x.length === 0);
}
